<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<div id="decryption-page" class="decryption-page">
    <div class="decrypt-info-area">
        <div class="decryption-infotext">
            <div><span>{{'FD_HEADER' | translate}}</span></div>
            <div><span>{{'FD_NOTE' | translate }}</span></div>
        </div>
        <app-recovery-key-request></app-recovery-key-request>
    </div>
    <div *ngIf="!isSecureContext" class="insecure-warning mat-error">
        <div><span>{{'FD_INSECURE' | translate}}</span></div>
    </div>

    <div class="decryption-content">
      <mat-card appearance="raised" class="form-container mat-elevation-z1">
        <mat-card-content>
            <div tabindex="0" [ngClass]="{'dropzone-on-enter': draggingOver, 'dropzone': !draggingOver}"
                 (keydown)="onkeydown($event)" role="button" aria-label="Browse for Files to Decrypt" class="dropzone"
                 appDndDropFile (fileDropped)="onFileDropped($event)"
                 (dragLeave)="onDragLeave()" (dragOver)="onDragOver()">
                <div style="display: flex; justify-content: center; align-items: center; height: 100%;">
                  <div *ngIf="!draggingOver; else placeholder;">
                    <input style="display: none;" type="file" accept=".d3e.*, .d3e.???, .d3e.????" #fileDropRef id="fileDropRef" multiple (change)="fileBrowseHandler($event.target.files)"/>
                    <span class="mdi mdi-cloud-upload-outline cloud-upload"></span>
                    <h3>{{fDrag}}</h3>
                    <h3>{{fOr}}</h3>
                    <div class="faux-button">
                      <button id="upload-code" mat-raised-button type="button" color="primary" (click)="fileDropRef.click()">{{fBrowse}}</button>
                    </div>
                  </div>
                </div>
                <ng-template #placeholder>
                  <div style="display: flex; justify-content: center; align-items: center; height: 100%;">
                    <div style="color: lightgray; font-size:1.25em;">{{'DRAG_DROP_HERE' | translate}}</div>
                  </div>
                </ng-template>
            </div>
        </mat-card-content>
      </mat-card>
      <mat-card appearance="raised" class="form-container mat-elevation-z1" style="flex-grow: 1;">
        <mat-card-content>
          <div class="files-list">
              <div class="files-list-header">
                  <div class="decrypt-files-label"><span class="download-label">{{fDecryptDL}}</span></div>
                  <div class="decrypt-buttons">
                          <button type="button" id="downloadall" class="decrypt-button" [disabled]="this.downloadsAvailable == false" color="primary" (click)="downloadAllFiles()" mat-raised-button>{{fDLAll}}</button>
                          <button type="button" id="clearall" class="decrypt-button" [disabled]="this.filenames.length == 0" color="primary" (click)="clearFiles()" mat-raised-button>{{fClear}}</button>
                  </div>
              </div>
              <div class="header-space"></div>
              <div class="file-info" *ngFor="let file of files; let i = index">
                <span *ngIf="allowShowHeader == false" class="download-list file-outline mdi mdi-file-outline"></span>
                <span *ngIf="allowShowHeader" matTooltip="View file header information" matTooltipPosition="above"
                      (click)="showHeaderInfo(i)" class="clickable download-list file-outline mdi mdi-file-outline">
                </span>
                <div class="info">
                  <h4 class="name">
                      <span *ngIf="this.fileStatus[i].error == false">{{ this.filenames[i] }} : {{this.fileStatus[i].message }}</span>
                      <span *ngIf="this.fileStatus[i].error" class="error-message">{{ this.filenames[i] }} : {{this.fileStatus[i].message }}</span>
                  </h4>
                  <app-progress [progress]="file?.progress"></app-progress>
                </div>
                <span *ngIf="ready[i]" (click)="downloadFile(i)"
                    class="download-button clickable download-list cloud-upload-in-list mdi mdi-cloud-upload-outline" >
                </span>
              </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
</div>
